import * as yup from 'yup'

const schema = yup.object({
  primaryIncludeSsi: yup.boolean().nullable().required('This field is required'),
  spouseIncludeSsi: yup
    .boolean()
    .nullable()
    .when('includeSpouse', {
      is: true,
      then: schema => schema.required('This field is required'),
      otherwise: schema => schema,
    }),
  primaryPaymentBeginAge: yup
    .number()
    .nullable()
    .when('primaryIncludeSsi', {
      is: true,
      then: schema => schema.required('This field is required'),
      otherwise: schema => schema,
    }),
  spousePaymentBeginAge: yup
    .number()
    .nullable()
    .when('spouseIncludeSsi', {
      is: true,
      then: schema => schema.required('This field is required'),
      otherwise: schema => schema,
    }),
  primaryReceivingSsi: yup
    .boolean()
    .nullable()
    .when(['primaryPaymentBeginAge', 'primaryCurrentAge'], {
      is: (primaryPaymentBeginAge, primaryCurrentAge) =>
        parseInt(primaryPaymentBeginAge) === primaryCurrentAge,
      then: schema => schema.required('This field is required'),
      otherwise: schema => schema,
    }),
  primaryMonthlyAmountCustom: yup
    .number()
    .nullable()
    .when(['primaryIncludeSsi', 'primaryReceivingSsi', 'primaryUseGcEstimate'], {
      is: (primaryIncludeSsi, primaryReceivingSsi, primaryUseGcEstimate) =>
        primaryIncludeSsi &&
        (primaryReceivingSsi || (!primaryReceivingSsi && primaryUseGcEstimate === false)),
      then: schema =>
        schema
          .min(1, 'Please enter an amount between $1 and $100,000,000')
          .max(100000000, 'Please enter an amount between $1 and $100,000,000')
          .required('Monthly amount is required'),
      otherwise: schema => schema,
    }),
  primaryUseGcEstimate: yup
    .boolean()
    .nullable()
    .when(['primaryIncludeSsi', 'primaryReceivingSsi'], {
      is: (primaryIncludeSsi, primaryReceivingSsi) =>
        primaryIncludeSsi && primaryReceivingSsi === false,
      then: schema => schema.required('This field is required'),
      otherwise: schema => schema,
    }),
  spouseUseGcEstimate: yup
    .boolean()
    .nullable()
    .when(['spouseIncludeSsi', 'spouseReceivingSsi'], {
      is: (spouseIncludeSsi, spouseReceivingSsi) =>
        spouseIncludeSsi && spouseReceivingSsi === false,
      then: schema => schema.required('This field is required'),
      otherwise: schema => schema,
    }),
  spouseMonthlyAmountCustom: yup
    .number()
    .nullable()
    .when(['spouseIncludeSsi', 'spouseReceivingSsi', 'spouseUseGcEstimate'], {
      is: (spouseIncludeSsi, spouseReceivingSsi, spouseUseGcEstimate) =>
        spouseIncludeSsi &&
        (spouseReceivingSsi || (!spouseReceivingSsi && spouseUseGcEstimate === false)),
      then: schema =>
        schema
          .min(1, 'Please enter an amount between $1 and $100,000,000')
          .max(100000000, 'Please enter an amount between $1 and $100,000,000')
          .required('Monthly amount is required'),
      otherwise: schema => schema,
    }),
})

export { schema }
